import {
  Container,
  MessageBody,
  MessageContainer,
  MessageIcon,
  MessageTitle,
} from "./styles";
import { DateTime } from "luxon";

const reformatMentions = (str) => {
  return str
    .replace(/@\[([^\]]+)\]\([^)]+\)/g, '<span class="mention">@$1</span>')
    .replace(/#\[([^\]]+)\]\([^)]+\)/g, '<span class="subtask">#$1</span>');
};

function MessageWithMentions({ message }) {
  const msg = reformatMentions(message);

  return <p dangerouslySetInnerHTML={{ __html: msg }} />;
}

const ChatComponent = ({ chat = [], user, date }) =>
  [...chat].reverse().map((item) => (
    <Container position={user._id !== item.userId} key={item._id}>
      <MessageIcon src={item.avatarURL} />
      <MessageContainer>
        <MessageTitle>
          {item.username}, {date(item.createdAt)}
        </MessageTitle>
        <MessageBody>
          <MessageWithMentions message={item.message} />
        </MessageBody>
      </MessageContainer>
    </Container>
  ));
const ChatReport = ({ chat, user }) => {
  const dateFormat = (msg) => {
    return DateTime.fromISO(msg)
      .setLocale("pt-br")
      .toFormat("HH:mm - dd MMM yyyy");
  };

  return <ChatComponent chat={chat} user={user} date={dateFormat} />;
};

export default ChatReport;
